import React from 'react'

export default function Loading (): JSX.Element {
  return (
    <div>
      Loading...
    </div>
  )
}
